// extracted by mini-css-extract-plugin
export default {"root":"Todos_root__yIP3g","list":"Todos_list__nykBZ","showMoreBtn":"Todos_showMoreBtn__sIt+R index_btn-icon__n2vie","noTodosInfo":"Todos_noTodosInfo__boFhs"};